import { notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";

import apollo from "@/helpers/apollo";
import { DEFAULT_SORT_OPTION } from "@/pages/user/components/sort-button/constants";
import { PAGE_SIZE } from "@/pages/user/reviews";
import { QUERY } from "@/pages/user/reviews/graphql";
import type { ReviewsDataType, ReviewsVariablesType } from "@/pages/user/types";

interface ReviewsInput {
  category?: string;
  reviewId?: string;
  sortBy?: string;
  subcategory?: string;
  username: string;
}

export const fetchReviews = createServerFn({ method: "GET" })
  .inputValidator((data: ReviewsInput) => data)
  .handler(async ({ data }) => {
    let sortBy = data.sortBy || DEFAULT_SORT_OPTION;

    if (sortBy === "MY_RATING") {
      sortBy = DEFAULT_SORT_OPTION;
    }

    const reviewId = data.reviewId || "";

    let filters: { categorySlugs: string[] } | undefined;
    if (data.category) {
      let filterCategory = data.category;
      if (data.subcategory) {
        filterCategory += `/${data.subcategory}`;
      }
      filters = { categorySlugs: [filterCategory] };
    }

    const client = apollo();
    const variables: ReviewsVariablesType = {
      filters,
      includeReview: reviewId !== "",
      isSSR: true,
      isUser: false,
      pageSize: PAGE_SIZE,
      reviewId,
      sortBy,
      username: data.username,
    };

    const response = await client.query<ReviewsDataType, ReviewsVariablesType>({
      fetchPolicy: "no-cache",
      query: QUERY,
      variables,
    });

    if (!response.data) {
      throw notFound();
    }

    return { variables, ...response.data };
  });
